import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=c6e40dee&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=c6e40dee&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e40dee')) {
      api.createRecord('c6e40dee', component.options)
    } else {
      api.reload('c6e40dee', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=c6e40dee&", function () {
      api.rerender('c6e40dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/admin.vue"
export default component.exports